import { Link } from "react-router-dom";

export const ProductCard = ({ product, description, index = 0 }) => (
  <Link
    to={`/products?focus=${product.id}`}
    data-testid={`product-card-${product.id}`}
    className="group flex flex-col border border-border bg-card transition-all duration-300 hover:-translate-y-1 hover:border-primary hover:shadow-xl"
  >
    <div className="relative aspect-square overflow-hidden bg-white">
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        className="h-full w-full object-contain p-6 transition-transform duration-500 group-hover:scale-105"
      />
      <span className="absolute left-0 top-0 bg-primary px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-white">
        {product.category}
      </span>
      {product.highlight && (
        <span className="absolute right-0 top-0 bg-foreground px-3 py-1 text-[10px] font-bold uppercase tracking-widest text-background">
          {product.highlight}
        </span>
      )}
    </div>
    <div className="flex flex-1 flex-col border-t border-border p-5">
      <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary">
        {product.brand}
      </span>
      <h3 className="mt-1 font-heading text-lg font-semibold leading-tight tracking-tight text-foreground">
        {product.name}
      </h3>
      {description && (
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-muted-foreground">
          {description}
        </p>
      )}
      {product.position && (
        <span className="mt-auto pt-3 text-xs font-medium tracking-wide text-muted-foreground">
          {product.position}
        </span>
      )}
    </div>
  </Link>
);
